import React, { useState, useEffect } from "react";
import './../styles/SustainReport.scss'
import downloadpng from './../img/downloadpng.png'
import Api from "../common/api";

const SustainReport = () => {

  const [datas, setData] = useState([])

  React.useEffect(() => {
    Api.get("/Documents/list/3").then((res) => {
      setData(res.data.items)
    });
  }, []);


  return (
    datas
      ? datas.map((data) => (
        <div key={data.id} className="report-card">
          <div className="report-sample-img">
            <img src={'https://sankoenerji.com.tr' + data.Document_type} alt="d" />
          </div>
          <div className="text-area">
            <h3>{data.Name_TR}</h3>
            <p><a href={'https://sankoenerji.com.tr' + data.Image} target="_blank">indirmek için tıklayınız.</a></p>
            <img src={downloadpng} alt="" />
          </div>
        </div >
      )) : null
  )
}

export default SustainReport
